// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"O8-z"};